import React from 'react';
import { useGesture } from 'react-use-gesture';
import { useSpring, a, config } from 'react-spring/three';
import { Texture } from 'three';
import assignIn from 'lodash/assignIn';
import { ReactThreeFiber, useThree } from 'react-three-fiber';

type ButtonProps = {
  onClick: (e?: any) => void;
  position?: ReactThreeFiber.Vector3;
  main?: {
    material?: {
      map?: Texture;
      color?: string;
      transparent?: boolean;
      opacity?: number;
    };
    width?: number;
    height?: number;
    size?: number;
  };
  children?: React.ReactChild;
};

const Button = ({ children, main, position, onClick }: ButtonProps) => {
  const { gl } = useThree();

  const [spring /* , set */] = useSpring(() => ({
    opacity: 0,
    config: config.gentle,
  }));

  const bind = useGesture({
    onClick: ({ event }) => {
      const evt = event as any;
      evt.nativeEvent.preventDefault();
      evt.nativeEvent.stopPropagation();
event.stopPropagation();
      onClick(event);
    },
    onHover: ({ hovering, event }) => {
      const evt = event as any;
      evt.nativeEvent.preventDefault();
      evt.nativeEvent.stopPropagation();
event.stopPropagation();

      if (hovering) {
        setTimeout(() => {
          gl.domElement.classList.add('cursor-pointer');
        });
      } else {
        gl.domElement.classList.remove('cursor-pointer');
      }

      // set({ opacity: hovering ? 1 : 0 });
    },
  });

  const mainProps = assignIn(
    {
      size: 0.1,
      material: {
        color: '#fff',
      },
    },
    main
  );

  return (
    <a.mesh position={position} {...bind()} renderOrder={4}>
      <planeBufferGeometry
        args={[mainProps.width || mainProps.size, mainProps.height || mainProps.size]}
        attach="geometry"
      />
      <a.meshBasicMaterial attach="material" {...mainProps.material} {...spring} />

      {children}
    </a.mesh>
  );
};

export default Button;
